import { Network } from '@capacitor/network';
import {
  IonHeader,
  IonItem,
  IonGrid,
  IonCol,
  IonRow,
  IonButton,
  IonButtons,
  IonMenuButton,
  IonToolbar,
  IonTitle,
  IonAlert,
  useIonRouter,
  IonIcon,
  useIonToast,
  IonSpinner,
  useIonAlert,
} from '@ionic/react';
import { arrowBack, documentTextOutline, prism } from 'ionicons/icons';
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import TimeAgo from 'timeago-react';

import packageJson from '../../package.json';
import LogOut from '../assets/Logout.svg';
import MenuIcon from '../assets/Menu.svg';
import RedDot from '../assets/Red.svg';
import Sync from '../assets/Sync.svg';
import defaultavatar from '../assets/avatardefault.svg';
import calender from '../assets/calender.svg';
import GreenDot from '../assets/green.svg';
import Homeicon from '../assets/homeicon.svg';
import bulb from '../assets/icons/bulb.svg';
import LogoWhite from '../assets/icons/logo-white.png';
import map from '../assets/icons/map.svg';
import model937 from '../assets/model937.svg';
import toolkit from '../assets/toolkit.svg';
import axios from '../axios';
import i18n from '../i18n';
import { createSurveyFields } from '../models/createSurveyFields';
import { AppContext } from '../providers/AppContext';
import { constant, deleteStorage, getStorage, setStorage } from '../utils';



const Header: React.FC<{ enableBackButton: string; title: string }> = ({ enableBackButton = '', title = '' }) => {
  const { dispatch, state } = useContext(AppContext);
  const [isOnline, setIsOnline] = useState(Boolean);
  const location = useLocation();


  const router = useIonRouter();

  const [offlineDataCount, setOfflineDataCount] = useState(0);
  const [failed, setFailed] = useState(0);
  const [isSync, setIsSync] = useState(false);
  const [successful, setSuccessful] = useState(0);
  const [requestCount, setRequestCount] = useState(0);
  const [isShowSyncMessage, setIsShowSyncMessage] = useState(false);
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);

  const [showHeadLoader, setShowHeadLoader] = useState(false);

  const [currentPath, setCurrentPath] = useState('');

  const { t } = useTranslation();
  const [present] = useIonToast();
  const [presentAlert] = useIonAlert();
  const canViewDocuments =
    state.permissions?.documents !== undefined
      ? Boolean(state.permissions.documents)
      : state.permissions?.document !== undefined
        ? Boolean(state.permissions.document)
        : true;

  // const [popoverState, setShowPopover] = useState({ showPopover: false, event: undefined });
  const [showPopover, setShowPopover] = useState(false);

  useEffect(() => {
    setCurrentPath(location.pathname);
    setIsOnline(true);

    (async () => {
      const internetStatus = await Network.getStatus();
      setIsOnline(internetStatus.connected);
      uploadOfflineData(internetStatus.connected);

      Network.addListener('networkStatusChange', (status) => {
        setIsOnline(status.connected);
      });
    })();
  }, [location]);



  const createLogs = async (data: any) => {
    const body = JSON.stringify({
      user_id: localStorage.getItem('email'),
      meta1: JSON.stringify(data),
      version: packageJson?.version
    });

    const configuration: any = {
      method: 'post',
      url: '/resource/Offline sync logs',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: body,
    };
    try {
      await axios(configuration);
    } catch (error: any) {
      console.log(error);
    }
  };

  const getLastUpdated = (): any => {
    try {
      const last: any = localStorage.getItem(constant.LAST_UPDATED_TIME);
      return last;
    } catch (e: any) {
      console.log(e);
      const raw = JSON.parse(e?.response?.data?._server_messages);
      console.log(JSON.parse(raw[0])?.message);
      createLogs({
        message: JSON.stringify(JSON.parse(raw[0])?.message || e),
        type: 'error in getLastUpdated',
        data: JSON.stringify(localStorage.getItem(constant.LAST_UPDATED_TIME)),
      })
      return null;
    }
  };

  const setLastUpdated = (): any => {
    localStorage.setItem(constant.LAST_UPDATED_TIME, new Date().toJSON());
  };


  const uploadOfflineData = async (online: boolean = isOnline) => {
    if (!online) {
      setShowOfflineAlert(true);
      return;
    }

    let dataLength = 0;
    let data: any[] = [];
    setOfflineDataCount(0);
    setRequestCount(0);
    setFailed(0);
    setSuccessful(0);
    const completedIndexes = [];
    try {
      data = await getStorage(constant.ALL_DATA_SYNC_TABLE, []);
      dataLength = data.length || 0;
      if (dataLength > 0) {
        setOfflineDataCount(dataLength);
        setIsSync(true);
      }

      // now start each object from the key data
      for (let index = 0; index < dataLength; index++) {
        const currentData = await getStorage(data[index]);
        if (!currentData) {
          completedIndexes.push(data[index]);
        }

        if (currentData && currentData['doc_type'] === 'Survey') {
          const formData = new FormData();
          for (const item in createSurveyFields) {
            const temp: any = createSurveyFields[item];
            if (temp.type === 'file') {
              try {
                setShowHeadLoader(true);
                const tempKey = await getStorage(temp.field + '-' + currentData['si_survey_code']);
                if (tempKey) {
                  const response = await fetch(tempKey);
                  const blob = await response.blob();
                  formData.append(
                    'file',
                    new File(
                      [blob],
                      `${currentData['si_survey_code']}-${new Date().getTime()}.${blob.type.slice(
                        blob.type.indexOf('/') + 1
                      )}`,
                      {
                        type: blob.type,
                      }
                    )
                  );
                  formData.append('is_private', '0');
                  formData.append('folder', 'Home');
                  formData.append('doctype', 'Survey');
                  const configfile: any = {
                    headers: {
                      Accept: 'application/json',
                      Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
                    },
                  };

                  const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
                  const urlPart = '/method/upload_file';
                  const fetchUrl = urlPart.startsWith('http')
                    ? urlPart
                    : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

                  const responseFetch = await fetch(fetchUrl, {
                    method: 'POST',
                    headers: configfile.headers,
                    body: formData,
                  });

                  if (!responseFetch.ok && responseFetch.status !== 200) {
                    const errorText = await responseFetch.text();
                    throw Object.assign(new Error(), { response: { data: errorText } });
                  }

                  const resData = await responseFetch.json();
                  currentData[temp.field] = resData.message.file_url;
                  formData.delete('file');
                  deleteStorage(temp.field + '-' + currentData['si_survey_code']);
                }
              } catch (error: any) {
                currentData[temp.field].value = '';
                console.log(error);
                const raw = JSON.parse(error?.response?.data?._server_messages);
                console.log(JSON.parse(raw[0])?.message);
                present({
                  message: JSON.parse(raw[0])?.message,
                  color: 'danger',
                  duration: 2000,
                });

                createLogs({
                  message: JSON.stringify(JSON.parse(raw[0])?.message || error),
                  type: 'error in uploadOfflineData',
                  data: currentData,
                })
              } finally {
                setShowHeadLoader(false);
              }
            }
          }
        } else if (currentData && currentData['doc_type'] === 'createAsset' && currentData?.data?.attachment?.src) {
          const formData = new FormData();
          try {
            const response = await fetch(currentData?.data.attachment?.src);
            const blob = await response.blob();
            formData.append(
              'file',
              new File([blob], `${new Date().getTime()}.${currentData?.data?.attachment?.format}`, {
                type: `image/${currentData?.data?.attachment?.format}`,
              })
            );
            formData.append('is_private', '0');
            formData.append('folder', 'Home');
            formData.append('doctype', 'Asset');
            const configuration: any = {
              headers: {
                Accept: 'application/json',
                Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
              },
            };

            const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
            const urlPart = '/method/upload_file';
            const fetchUrl = urlPart.startsWith('http')
              ? urlPart
              : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

            const responseFetch = await fetch(fetchUrl, {
              method: 'POST',
              headers: configuration.headers,
              body: formData,
            });

            if (!responseFetch.ok && responseFetch.status !== 200) {
              const errorText = await responseFetch.text();
              throw Object.assign(new Error(), { response: { data: errorText } });
            }

            const resData = await responseFetch.json();
            currentData.data.attachment = resData.message.file_url;
            formData.delete('file');
          } catch (error: any) {
            console.log(error);
          }
        }

        // upload rest data
        const config: any = {
          method: 'post',
          url: currentData.base_url_offline_sync,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
          },
          data: JSON.stringify(currentData),
        };
        try {
          setShowHeadLoader(true);
          const response = await axios(config);
          if (currentData['doc_type'] === 'createAsset') {
            present({
              message: 'Asset uploaded!',
            })
          } else {
            present({
              message:
                response?.data?.data?.doctype +
                (response?.data?.data?.si_survey_code ? ' ' + response.data.data.si_survey_code : '') +
                ' uploaded!',
              color: 'secondary',
              duration: 2000,
            });
          }
          setSuccessful((prevSuccessful) => prevSuccessful + 1);
          // setOfflineDataCount(dataLength - 1);
          // now delete the data
          await deleteStorage(data[index]);
          // now delete the key from main array
          completedIndexes.push(data[index]);
        } catch (e: any) {
          setFailed((prevFailure) => prevFailure + 1);
          const raw = JSON.parse(e?.response?.data?._server_messages);
          console.log(JSON.parse(raw[0])?.message);
          createLogs({
            message: JSON.stringify(JSON.parse(raw[0])?.message || e),
            type: 'error in uploadOfflineData',
            data: currentData,
          })
        }
        setRequestCount((prevRequestCount) => prevRequestCount + 1);
      }
    } catch (e: any) {
      console.log(e);
      const raw = JSON.parse(e?.response?.data?._server_messages);
      console.log(JSON.parse(raw[0])?.message);
      createLogs({
        message: JSON.stringify(JSON.parse(raw[0])?.message || e),
        type: 'error in uploadOfflineData',
        data: await getStorage(constant.ALL_DATA_SYNC_TABLE, [])
      })
    } finally {
      setShowHeadLoader(false);
      // set the last updated time if there is data in storage
      if (dataLength !== 0) {
        setIsShowSyncMessage(true);
        setLastUpdated();
        // delete all extra keys
        completedIndexes.forEach((comp) => {
          data = data.splice(comp, 1);
          return null;
        });
        // set the last main list
        setStorage(constant.ALL_DATA_SYNC_TABLE, data);
      }
    }
  };


  const getImg = () => {
    if (localStorage.getItem(constant.PROFILE_PHOTO))
      return `${localStorage.getItem('baseUrl')?.replace('/api', '')}${localStorage.getItem(constant.PROFILE_PHOTO)}`;
    else return defaultavatar
  }

  const navigationFunc = (path: string) => {
    router.push(path);
  };

  // Check if the current tab is active
  const isActiveTab = (tabPath: any) => {
    return tabPath === currentPath;
  };

  const navigateBack = (enableBackButton: any) => {
    if (enableBackButton === 'goBack') return router.goBack();
    else return router.push(enableBackButton);
  };

  return (
    <IonHeader
      style={{
        background: 'linear-gradient(135deg, #1d508d 0%, #0f3460 100%)',
        boxShadow: enableBackButton ? 'none' : '0 4px 16px rgba(0,0,0,0.15)',
        borderBottom: '1px solid rgba(255,255,255,0.05)'
      }}
    >
      {enableBackButton ? (
        <IonToolbar style={{ '--background': 'transparent' }}>
          <IonButtons slot="start" style={{ zIndex: '1' }} onClick={() => navigateBack(enableBackButton)}>
            <IonIcon
              src={arrowBack}
              className="pointer"
              style={{ paddingLeft: '16px', fontSize: '24px', color: '#fff' }}
            />
          </IonButtons>
          <IonTitle style={{ color: '#fff', fontSize: 17, fontWeight: 700, paddingLeft: 8 }}>
            {title}
          </IonTitle>
        </IonToolbar>
      ) : (
        <div style={{ position: 'relative', width: '100%', top: '0', paddingTop: 'env(safe-area-inset-top)' }}>
          {/* Top Row: Menu + Logo + Profile */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px' }}>
            <IonMenuButton className="header-menu-button" style={{ color: '#fff', marginLeft: -8, width: 44, height: 44 }}>
              <img src={MenuIcon} alt="menu" style={{ width: 20 }} />
            </IonMenuButton>

            <img src={process.env.REACT_APP_WHITE_LOGO || LogoWhite} alt="hyprism" className="header-logo" style={{ height: 26, objectFit: 'contain' }} />

            <div style={{ position: 'relative' }}>
              {showPopover && (
                <div style={{
                  position: 'absolute', top: 44, right: 0, width: 170,
                  background: '#fff', borderRadius: 16, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', padding: '8px', zIndex: 100
                }}>
                  <NavLink
                    to="../profile"
                    onClick={() => setShowPopover(false)}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px', textDecoration: 'none', color: '#1d2d44', borderRadius: 10, cursor: 'pointer' }}
                  >
                    <img src={getImg()} alt="Profile" style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover' }} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{t('Header.Avatar.Profile')}</span>
                  </NavLink>
                  <div
                    onClick={() => {
                      setShowPopover(false);
                      presentAlert(t('Utils.are_you_sure'), [
                        { text: t('Utils.no'), role: 'cancel', cssClass: 'secondary' },
                        { text: t('Utils.yes'), cssClass: 'danger', handler: () => dispatch({ type: 'logOut' }) },
                      ]);
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px', color: '#e03c5a', borderRadius: 10, cursor: 'pointer', marginTop: 4 }}
                  >
                    <img src={LogOut} alt="Logout" style={{ width: 22 }} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{t('Header.Avatar.LogOut')}</span>
                  </div>
                </div>
              )}
              <div
                onClick={() => setShowPopover(!showPopover)}
                style={{
                  width: 36, height: 36, borderRadius: '50%', padding: 2, background: 'rgba(255,255,255,0.2)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}
              >
                <img src={getImg()} alt="account" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
              </div>
            </div>
          </div>

          {/* Details Row: Greeting & Sync */}
          <div style={{ padding: '0 16px 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ flex: 1, minWidth: 140 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: isOnline ? '#2ed573' : '#ff4757', boxShadow: `0 0 8px ${isOnline ? 'rgba(46,213,115,0.5)' : 'rgba(255,71,87,0.5)'}` }} />
                <span style={{ fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.8)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                  {isOnline ? t('Header.Online') : t('Header.Offline')}
                </span>
              </div>
              <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#fff' }}>
                {t('Header.Greet')}, {localStorage.getItem('fullName') || localStorage.getItem('email')}!
              </p>
              {!isOnline && getLastUpdated() && (
                <p style={{ margin: '4px 0 0', fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>
                  {t('Header.Update')} <TimeAgo datetime={getLastUpdated()} locale={i18n.language.toLocaleUpperCase()} />
                </p>
              )}
            </div>

            <div onClick={() => uploadOfflineData()} style={{
              display: 'flex', alignItems: 'center', gap: 6,
              background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
              padding: '6px 12px', borderRadius: 20, cursor: 'pointer', flexShrink: 0
            }}>
              <img src={Sync} alt="sync" style={{ width: 14, filter: 'brightness(10)' }} />
              <span style={{ fontSize: 12, fontWeight: 600, color: '#fff' }}>
                {isSync && !(requestCount === 0 && offlineDataCount === requestCount)
                  ? `${requestCount}/${offlineDataCount}`
                  : t('Header.Sync')}
              </span>
            </div>
            <IonAlert
              isOpen={isShowSyncMessage}
              onDidDismiss={() => setIsShowSyncMessage(false)}
              header={t('Utils.sync')}
              message={`${requestCount}/${offlineDataCount}<br/>${failed} ${t('Utils.failed')} <br/> ${successful} ${t('Utils.success')}`}
              buttons={[{ text: t('Utils.okay'), handler: () => setIsShowSyncMessage(false) }]}
            />
            <IonAlert
              isOpen={showOfflineAlert}
              onDidDismiss={() => setShowOfflineAlert(false)}
              header={t('Utils.no_internet')}
              message={t('Utils.no_net_message')}
              buttons={[{ text: t('Utils.okay'), handler: () => setShowOfflineAlert(false) }]}
            />
          </div>

          {/* Navigation Tab Row */}
          {!!state.slideOpts.loadSlide && (
            <div className="nav-pills-container" style={{
              display: 'flex', gap: 6, overflowX: 'auto', padding: '10px 16px 14px',
              scrollbarWidth: 'none', msOverflowStyle: 'none'
            }}>
              <style>{`
                .nav-pills-container {
                   display: flex;
                }
                @media (min-width: 768px) {
                  .nav-pills-container,
                  .header-menu-button,
                  .header-logo {
                    display: none !important;
                  }
                }
                .nav-pill {
                  flex-shrink: 0; display: flex; align-items: center; justify-content: center;
                  width: 44px; height: 44px; border-radius: 14px;
                  background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.08); transition: all 0.2s;
                }
                .nav-pill.active {
                  background: rgba(255,255,255,0.25); border: 1px solid rgba(255,255,255,0.4); box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                .nav-pill img, .nav-pill ion-icon { width: 22px; height: 22px; filter: brightness(100); }
                .nav-pill ion-icon { font-size: 22px; color: #fff; }
              `}</style>
              {!!state.permissions.home && (
                <div className={`nav-pill ${isActiveTab('/home') ? 'active' : ''}`} onClick={() => navigationFunc('../home')} >
                  <img src={Homeicon} alt="home" />
                </div>
              )}
              {!!state.permissions.project && (
                <div className={`nav-pill ${isActiveTab('/project') ? 'active' : ''}`} onClick={() => navigationFunc('/project')} >
                  <IonIcon src={prism} />
                </div>
              )}
              {!!canViewDocuments && (
                <div className={`nav-pill ${isActiveTab('/documents') ? 'active' : ''}`} onClick={() => navigationFunc('/documents')} >
                  <IonIcon icon={documentTextOutline} style={{ color: 'white' }} />
                </div>
              )}
              {!!state.permissions.assets && (
                <div className={`nav-pill ${isActiveTab('/assets') ? 'active' : ''}`} onClick={() => navigationFunc('/assets')} >
                  <img src={bulb} alt="assets" />
                </div>
              )}
              {!!state.permissions.service && (
                <div className={`nav-pill ${isActiveTab('/servicehome') ? 'active' : ''}`} onClick={() => navigationFunc('../servicehome')} >
                  <img src={toolkit} alt="service" />
                </div>
              )}
              {!!state.permissions.maintenance && (
                <div className={`nav-pill ${isActiveTab('/maintenanceHome') ? 'active' : ''}`} onClick={() => navigationFunc('../maintenanceHome')} >
                  <img src={calender} alt="maintenance" />
                </div>
              )}
              {!!state.permissions.model && (
                <div className={`nav-pill ${isActiveTab('/model-home') ? 'active' : ''}`} onClick={() => navigationFunc('../model-home')} >
                  <img src={model937} alt="model" />
                </div>
              )}
              {!!state.permissions.survey && (
                <div className={`nav-pill ${isActiveTab('/survey-home') ? 'active' : ''}`} onClick={() => navigationFunc('/survey-home')} >
                  <img src={map} alt="survey" />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {showHeadLoader && (
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          background: 'rgba(255,255,255,0.95)', padding: '6px 0', borderTop: '1px solid rgba(0,0,0,0.05)',
          color: '#1d508d', fontSize: 13, fontWeight: 700, gap: 8
        }}>
          Uploading <IonSpinner name="crescent" style={{ width: 16, height: 16 }} />
        </div>
      )}
    </IonHeader>
  );
};

export default Header;
